import { Button } from "@Components/CustomButton/Button"
import SvgMusculationIcon from "@Components/CustomIcon/SvgMusculationIcon"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { ActivityCard } from "@Components/FollowUp/Toolbox/ActivityCard"
import { CustomCalendar } from "@Components/FollowUp/Toolbox/CustomCalendar"
import { Spacer } from "@Components/Space"
import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { baseColors } from "@Constants/baseStyles"
import { message } from "@Constants/constant"
import { activityTypesAtom } from "@Recoil/Atom/activityAtom"
import { userAtom } from "@Recoil/Atom/userAtom"
import { ActivityService } from "@Services/Activity.Service"
import { dbDateFormat } from "@Utils/utils"
import moment from "moment"
import React, { useEffect, useRef, useState } from "react"
import { Dimensions, StyleSheet, View } from "react-native"
import { ActivityIndicator, IconButton } from "react-native-paper"
import { SwipeListView } from "react-native-swipe-list-view"
import { useRecoilState, useRecoilValue } from "recoil"
import { MaterialCommunityIcons } from "@expo/vector-icons"

const { width, hieght } = Dimensions.get("screen")
export const ToolboxProgram = ({ navigation }) => {
    const swipeableRef = useRef(null)
    const user = useRecoilValue(userAtom)
    const [activities, setActivities] = useState([])
    const [loading, setLoading] = useState(false)
    const [states, setStates] = useState([])
    const [udpating, setUpdating] = useState(false)
    const [selectedDate, setSelectedDate] = useState(new Date())
    const [activitiesType, setActivitiesType] = useRecoilState(activityTypesAtom)

    const fetchActivityTypes = () => {
        ActivityService.getType()
            .then((response) => {
                const data = response.data?.data
                if (data) {
                    const parsedData = data.map((item) => {
                        let newObj = {
                            id: item.id,
                            code: item.code,
                            label: item.name
                        }
                        return newObj
                    })
                    setActivitiesType(parsedData)
                }
            })
            .catch((e) => {
                ShowToast({ type: "error", message: message.serverError })
            })
    }

    const fetchActivityState = () => {
        setLoading(true)
        ActivityService.getState()
            .then((response) => {
                const data = response.data?.data
                if (data) {
                    setStates(data)
                }
                setLoading(false)
            })
            .catch((e) => {
                setLoading(false)
                ShowToast({ type: "error", message: message.serverError })
            })
    }

    const fetchActivity = (date) => {
        if (user?.id) {
            setLoading(true)
            ActivityService.getPatientsActivity(user.id, moment(date).format(dbDateFormat))
                .then((response) => {
                    const data = response.data.data
                    if (data) {
                        setActivities(data)
                    }
                    setLoading(false)
                })
                .catch((e) => {
                    setLoading(false)

                    ShowToast({ type: "error", message: message.serverError })
                })
        } else {
            alert("No user connected")
        }
    }

    const updateActivity = (rowData, newStateCode) => {
        const state = states.filter((st) => st.code === newStateCode)
        if (state.length > 0) {
            setUpdating(true)
            ActivityService.update(rowData.item.id, { stateId: state[0].id })
                .then((response) => {
                    setUpdating(false)
                    fetchActivity(selectedDate)
                })
                .catch((e) => {
                    ShowToast({ type: "error", message: message.serverError })
                    setUpdating(false)
                })
        }
    }

    useEffect(() => {
        fetchActivity(selectedDate)
        fetchActivityState()
        fetchActivityTypes()
    }, [])

    const renderItem = (data, rowMap) => {
        return (
            <ActivityCard
                onPress={() => navigation.navigate("ActivityFollowUP", { activity: data.item })}
                {...data.item}
            />
        )
    }

    useEffect(() => {
        const unsubscribe = navigation.addListener("focus", () => {
            fetchActivity(selectedDate)
        })

        // Return the function to unsubscribe from the event so it gets removed on unmount
        return unsubscribe
    }, [navigation])

    return (
        <View style={styles.container}>
            <Spacer height={20} />
            <CustomCalendar
                disabled={loading}
                handleChange={(date) => {
                    fetchActivity(date)
                    setSelectedDate(date)
                }}
            />
            <Spacer height={20} />
            {!loading && activities.length === 0 && (
                <View
                    style={{
                        borderColor: baseColors.green.primary,
                        borderWidth: 1,
                        borderRadius: 8,
                        flexGrow: 1,
                        flex: 1,
                        display: "flex",
                        padding: 20,
                        width: width - 60
                    }}
                >
                    <OpenSansText
                        color={baseColors.green.primary}
                        style={{ textAlign: "center", paddingLeft: 60, paddingRight: 60 }}
                        fontSize={18}
                    >
                        Vous n'avez programmé aucune activité
                    </OpenSansText>
                </View>
            )}
            {loading ? (
                <ActivityIndicator color={baseColors.green.primary} />
            ) : (
                <SwipeListView
                    ref={swipeableRef}
                    data={activities}
                    renderItem={renderItem}
                    closeOnRowOpen
                    closeOnScroll
                    closeOnRowPress
                    closeOnRowBeginSwipe
                    renderHiddenItem={(data, rowMap) => (
                        <View style={styles.swipeableContainer}>
                            <View>
                                <IconButton
                                    disabled={data.item.state.code !== "CREATED"}
                                    onPress={() => updateActivity(data, "FINISHED")}
                                    rippleColor={"rgba(0,0,0,0.05)"}
                                    icon="check"
                                    color={baseColors.white}
                                    size={40}
                                    style={{
                                        borderRadius: 10,
                                        backgroundColor: baseColors.green.primary
                                    }}
                                />
                            </View>
                            <View>
                                <Button
                                    disabled={data.item.state.code !== "CREATED"}
                                    marginTop={0}
                                    text="Annuler"
                                    width="100%"
                                    onPress={() => updateActivity(data, "CANCELED")}
                                    backgroundColor={baseColors.orange.primary}
                                    labelColor={"white"}
                                />
                            </View>
                        </View>
                    )}
                    leftOpenValue={80}
                    rightOpenValue={-125}
                />
            )}

            <Button
                text="Ajouter une activité"
                width="70%"
                disabled={activitiesType.length === 0}
                onPress={() => navigation.navigate("ActivityForm")}
                backgroundColor={baseColors.green.primary}
                labelColor={"white"}
            />
        </View>
    )
}

const styles = StyleSheet.create({
    cardContainer: {
        marginVertical: 5,
        flexDirection: "row",
        backgroundColor: baseColors.green.primary,
        borderRadius: 10,
        padding: 20,
        flex: 1,
        width: width - 40,
        justifyContent: "space-between"
    },
    swipeableContainer: {
        width: width - 40,
        flexDirection: "row",
        alignItems: "center",
        alignContent: "center",
        flex: 1,
        justifyContent: "space-between"
    },
    container: {
        backgroundColor: baseColors.white,
        flex: 1,
        padding: 0,
        alignItems: "center"
    }
})
